
import { defineComponent } from "vue";
export default defineComponent({
  props: {
    title: {
      type: String,
      default: "Lorem, ipsum dolor.",
    },
    number: {
      type: Number,
      default: 0,
    },
    entity: {
      type: String,
      default: "",
    },
  },
  data: () => ({}),
});
